import React, { useState, useEffect } from 'react';
import { ArrowUp, MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';

const fabItems = [
  { icon: <ArrowUp size={18} />, label: 'Back to Top', action: () => window.scrollTo({ top: 0, behavior: 'smooth' }) },
  { icon: <MapPin size={18} />, label: 'Directions', href: 'https://maps.google.com/?q=Seguku+Entebbe+Road+Uganda', target: '_blank' },
  { icon: <Calendar size={18} />, label: 'Reserve', href: '/booking' },
  { icon: <MessageCircle size={18} />, label: 'WhatsApp', href: 'https://wa.me/256772206129', target: '_blank' },
  { icon: <Phone size={18} />, label: 'Call', href: 'tel:+256772206129' },
];

const FloatingActionMenu = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (open && !e.target.closest('.fab-container')) setOpen(false);
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [open]);

  return (
    <div className="fab-container">
      <div className={`fab-menu ${open ? 'open' : ''}`}>
        {fabItems.map((item, i) => (
          item.action ? (
            <button key={i} onClick={item.action} style={{
              display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 20px',
              background: '#fff', borderRadius: '100px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
              border: 'none', cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500,
              whiteSpace: 'nowrap', transition: 'all 0.3s ease', color: '#2C2C2C'
            }}>
              {item.icon} {item.label}
            </button>
          ) : (
            <a key={i} href={item.href} target={item.target || undefined}
               rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}>
              {item.icon} {item.label}
            </a>
          )
        ))}
      </div>
      <button className={`fab-main ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}
        aria-label="Quick actions menu">
        ✦
      </button>
    </div>
  );
};

export default FloatingActionMenu;
